import React, { Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import Loader from "../components/Loader";

const SignIn = React.lazy(() => import("../pages/SignIn"));
const Code = React.lazy(() => import("../pages/Code"));
const Reset = React.lazy(() => import("../pages/Reset"));
const Vertical = React.lazy(() => import("../pages/Vertical"));
const Share = React.lazy(() => import("../pages/Share"));

export const router = createBrowserRouter([
  {
    path: "/share",
    element: (
      <Suspense fallback={<Loader />}>
        <Share />
      </Suspense>
    ),
  },
  {
    path: "/share/:code",
    element: (
      <Suspense fallback={<Loader />}>
        <Share />
      </Suspense>
    ),
  },
  {
    path: "/login",
    element: (
      <Suspense fallback={<Loader />}>
        <SignIn />
      </Suspense>
    ),
  },
  {
    path: "/reset",
    element: (
      <Suspense fallback={<Loader />}>
        <Reset />
      </Suspense>
    ),
  },
  {
    path: "/code/:code",
    element: (
      <Suspense fallback={<Loader />}>
        <Code />
      </Suspense>
    ),
  },
  {
    path: "/v/:rotation",
    element: (
      <Suspense fallback={<Loader />}>
        <Vertical />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: (
      <Suspense fallback={<Loader />}>
        <SignIn />
      </Suspense>
    ),
  },
]);
